import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import ApplicationContext from "../../../context/ApplicationContext";
import { getSettings, storeVariation } from "../../../services/Service";
import { ISearchData } from "../../../types/ISearchData";
import { IVariation } from "../../../types/IVariation";
import { useNavigate, useParams } from "react-router-dom";

export const AddVariation: React.FC = (): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [searchData, setSearchData] = useState<ISearchData[]>([]);
  const [searchValue, setSearchValue] = useState("Home");

  const [productId, setProductId] = useState(1);
  const [description, setDescription] = useState("");
  const [imageURL, setImageUrl] = useState("default.png");
  const [position, setPosition] = useState("");
  const [price, setPrice] = useState("0.00");
  const [qty, setQty] = useState("");
  const [isCategory, setIsCategory] = useState(false);
  const [saving, setSaving] = useState(false);

  const [isValidDescription, setIsInvalidDescription] = useState(false);
  const [isValidPrice, setIsInvalidPrice] = useState(false);

  const navigate = useNavigate();
  const { nav } = useParams();

  async function getBranchSettings() {
    const response = await getSettings(context.AuthenticatedUser.getToken());

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    let searchData: ISearchData[] = [];
    response.menu.products.forEach((p) => {
      const d: ISearchData = {
        productId: p.id,
        value: p.id.toString(),
        key: p.id.toString(),
        text: p.description,
        barcode: "",
      };
      searchData.push(d);
    });
    setSearchData(searchData);

    context.BranchMenu.setMenu(response.menu);
  }

  useEffect(() => {
    getBranchSettings();
  }, []);

  function findProductByProductId(id: number) {
    return context.BranchMenu.getMenu().products.find((element) => {
      return element.id === id;
    });
  }

  function validateMe() {
    let valid = true;

    //check for description
    if (description.length === 0) {
      setIsInvalidDescription(true);
      valid = false;
    } else {
      setIsInvalidDescription(false);
    }

    const p = parseFloat(price);
    if (price.length === 0 || isNaN(p)) {
      setIsInvalidPrice(true);
      valid = false;
    } else {
      setIsInvalidPrice(false);
    }

    return valid;
  }

  async function save() {
    const valid = validateMe();

    if (valid === false) {
      return;
    }

    const newVariation: IVariation = {
      id: 0,
      uuid: "",
      optionId: 0,
      description: description,
      image: imageURL,
      position: 0,
      price: Number(price),
      qty: 0,
    };

    setSaving(true);

    const saved = storeVariation(
      newVariation,
      context.AuthenticatedUser.getToken()
    );

    if (!saved) {
      context.ApplicationError.addError("storing error");
      return;
    }

    await sleep(2000);

    setSaving(false);

    if (nav !== undefined) {
      navigate("/TreeView");
      return;
    }

    navigate("/Variations");
  }

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  const add = (): JSX.Element => (
    <>
      <div className="container">
        <h1>Add Variation</h1>
        <hr />
        <Form>
          <Form.Group
            as={Row}
            className="mb-3"
            controlId="formHorizontalPassword"
          >
            <Form.Label column sm={2}>
              Description
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                isInvalid={isValidDescription}
                required={true}
                type="text"
                placeholder="Description"
                onChange={(e) => setDescription(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group
            as={Row}
            className="mb-3"
            controlId="formHorizontalPassword"
          >
            <Form.Label column sm={2}>
              Image URL
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                placeholder="Image URL"
                value={imageURL}
                onChange={(e) => setImageUrl(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group
            as={Row}
            className="mb-3"
            controlId="formHorizontalPassword"
          >
            <Form.Label column sm={2}>
              Price
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                placeholder="Price"
                isInvalid={isValidPrice}
                defaultValue={(0).toFixed(2)}
                onChange={(e) => setPrice(e.target.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="mb-3">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button
                variant="primary"
                size="lg"
                disabled={saving}
                onClick={save}
              >
                {saving ? "Saving..." : "Create"}
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </>
  );

  return <>{add()}</>;
};
